import type { DataGridSortingState } from '@ibsys/kit';
import type { PhraseSortKey } from '@/entities/phrases';

/** Колонки перечня реплик; id колонки — он же ключ отбора и сортировки */
export const PHRASE_COLUMNS = {
  conversationId: 'conversationId',
  text: 'text',
  duration: 'duration',
  updatedAt: 'updatedAt',
} as const;

/** Запас звучания с каждого края реплики у прослушивания с запасом, мс */
export const PHRASE_PADDING_MS = 2000;

/** Колонки, по которым перечень упорядочивается на сервере */
export const SORTABLE_PHRASE_COLUMNS: Record<string, PhraseSortKey> = {
  [PHRASE_COLUMNS.duration]: 'duration',
  [PHRASE_COLUMNS.updatedAt]: 'updatedAt',
};

/** Порядок по умолчанию: обновлённые позже первыми */
export const DEFAULT_PHRASE_SORTING: DataGridSortingState = [{ columnId: PHRASE_COLUMNS.updatedAt, direction: 'desc' }];

/** Размер страницы перечня */
export const PHRASES_PAGE_SIZE = 50;

/** Размеры страницы, доступные пользователю */
export const PHRASES_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
